document.body.addEventListener(
    "click",
    function (ev) {
    const target = ev.composedPath().find(
        (el) =>
        el instanceof Element &&
        el.matches(
            ".prompt-product-image, .prompt-product-details-title, .prompt-product-details-description, .prompt-product-details-help"
        )
    );

    if (target) {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();

        window.open(
        "https://buysnacksonline.com/pages/hassle-free-delivery-guarantee",
        "_blank",
        "noopener,noreferrer"
        );
    }
    },
    true
);

(function () {
  function setupShipAidWidget(widget) {
    const shadowRoot = widget.shadowRoot;

    if (!shadowRoot) return;

    // Prevent duplicate styles
    if (shadowRoot.querySelector("#shipaid-custom-cursor")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "shipaid-custom-cursor";

    style.textContent = `
      .prompt-product-image,
      .prompt-product-details,
      .prompt-product-details * {
        cursor: pointer !important;
      }
      .prompt-product-image {
        filter: brightness(0) !important;
      }
    `;

    shadowRoot.appendChild(style);
  }

  function findShipAidWidgets() {
    document.querySelectorAll("shipaid-widget").forEach(setupShipAidWidget);
  }

  // Check immediately
  findShipAidWidgets();

  // Watch for ShipAid being dynamically added
  const observer = new MutationObserver(findShipAidWidgets);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
